module.exports = __webpack_public_path__ + "static/js/2.4d145f19.chunk.worker.js"